import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Travel } from '../../shared/models/domain/travel';
import { TravelPoint } from '../../shared/models/domain/travel-point';
import { AppSettingsService } from '../../services/app-settings/app-settings.service';
import * as moment from 'moment';
import { Distribution } from '../../shared/models/domain/distribution';
import { ApiService } from '../../services/api/api.service';
import { ScreenUtils } from '../../utils/screen.utils';
import { URLParamsConstants } from '../../utils/constants/UrlConstants';
import { SearchboxBarV2Component, SearchboxV2Service } from '@shopping-angular-components/searchbox-v2';
import { T_CLI } from 'src/app/utils/constants/constants';
import { TrackingData } from 'src/app/models/searchBoxv2/tracking-data';
import { SearchboxModelv2 } from 'src/app/models/searchBoxv2/searchbox-modelv2';
import { GeoItem } from 'src/app/models/searchBoxv2/geo-item';
import { SearchboxDisplay } from 'src/app/models/searchBoxv2/searchbox-display';
import { StaticValuesUtils } from 'src/app/utils/static-values/static-values.utils';

@Component({
    selector: 'transfer-searchbox',
    templateUrl: './transfer-searchbox.component.html',
    styleUrls: ['./transfer-searchbox.component.scss'],
})
export class TransferSearchboxComponent implements OnInit {
    @Input() travel: Travel;
    @ViewChild(SearchboxBarV2Component, { static: true }) searchboxbarComponent: SearchboxBarV2Component;

    searchboxHtml: any;
    searchboxModel: SearchboxModelv2;
    sboxDisplay: SearchboxDisplay;
    isRoundtrip: boolean = false;
    fromDate: string;
    toDate: string;
    comesFromOffers: boolean;
    locale: string;
   
    constructor(
        private activatedRoute: ActivatedRoute,
        private appSettingsService: AppSettingsService,
        private apiService: ApiService,
        private searchboxV2Service: SearchboxV2Service,        
    ) {}

    ngOnInit() {
        this.comesFromOffers = !!this.activatedRoute.snapshot.queryParams['fromOffers'];
        this.isRoundtrip = this.getParameterFromURL(URLParamsConstants.TRAVEL_TYPE).toUpperCase() === 'ROUNDTRIP';
        this.fromDate = this.getParameterFromURL(URLParamsConstants.FROM_DATE);
        this.toDate = this.getParameterFromURL(URLParamsConstants.TO_DATE);
        this.locale = this.appSettingsService.getLocale();
        this.setSearchboxModel();
        this.setSearchboxDisplay();
        if (this.comesFromOffers && ScreenUtils.isDesktop()) this.searchboxbarComponent.show();

    }

    private setSearchboxModel() {
        // Get the searchbox model from StaticValues and create a copy
        const staticSearchboxModel = StaticValuesUtils.searchBoxModel();
        this.searchboxModel = staticSearchboxModel ? { ...staticSearchboxModel } : this.emptySearchboxModel();

        let trackingData = new TrackingData();
        trackingData.cc = this.appSettingsService.getSite();
        trackingData.ch = this.appSettingsService.getChannel();
        trackingData.fl = this.appSettingsService.getFlow();
        trackingData.locale = this.locale;
        trackingData.tcli = T_CLI;
        trackingData.xClient = this.appSettingsService.getProduct();
        trackingData.context = this.appSettingsService.getFlow();
        trackingData.pageview_id = this.appSettingsService.getPageViewId();
        trackingData.userid = this.appSettingsService.getUserId();
        trackingData.company_id = this.appSettingsService.getCompanyId();
        this.searchboxModel.trackingData = trackingData;
    }

    private emptySearchboxModel() : SearchboxModelv2 {
        this.searchboxModel = new SearchboxModelv2();        
        this.searchboxModel.origin = new GeoItem;        
        this.searchboxModel.destination = new GeoItem;
        return this.searchboxModel;
    }

    private setSearchboxDisplay() {
        this.sboxDisplay = new SearchboxDisplay();
        this.sboxDisplay.from = this.travel ? this.getPointDescription(this.travel.points[0]) : '-';
        this.sboxDisplay.to = this.travel ? this.getPointDescription(this.travel.points[1]) : '-';
        this.sboxDisplay.fromDate = this.formatDisplayDate(this.fromDate);
        this.sboxDisplay.fromTime = this.getParameterFromURL(URLParamsConstants.FROM_TIME);
        this.sboxDisplay.fromYear = this.getYearFromUrl(URLParamsConstants.FROM_TIME);

        if (this.isRoundtrip) {
            this.sboxDisplay.toDate = this.formatDisplayDate(this.toDate);
            this.sboxDisplay.toTime = this.getParameterFromURL(URLParamsConstants.TO_TIME);
            this.sboxDisplay.toYear = this.getYearFromUrl(URLParamsConstants.TO_TIME);
        }

        this.sboxDisplay.passengerQty = this.getPassengerQty();

    }

    private getPointDescription(point: TravelPoint) {
        if (point.type === 'AIRPORT') return point.id;
        return point.description;
    }

    private getParameterFromURL(param: string): string {
        return this.activatedRoute.snapshot.paramMap.get(param);
    }

    private getYearFromUrl(date: string): string {
        return date.split('-')[2];
    }

    private formatDisplayDate(date): string {
        moment.locale(this.locale);
        const newDate = moment(date, 'DD/MM/YYYY');
        const dateDisplay = newDate.format('ddd D MMM');
        return dateDisplay;
    }

    public getPassengerQty() {
        const distribution: Distribution = this.apiService.getCurrentDistribution();
        return parseInt(distribution.adults) + this.getChildrenQty(distribution.children);
    }

    private getChildrenQty(children) {
        if (children) {
            return children.split(',').length;
        } else return 0;
    }
}
